import React from 'react';
import { useSelector } from 'react-redux';
import { getFeatureFlags } from 'utils/feature-flags';
import { getProducts } from 'redux/modules/entities/selectors/products';

import { RecipeProductTypes } from 'api/definitions/recipes/types';

import ProductGrid from 'components/ProductGrid/ProductGrid';

const productsDefaultPropProducts = [];

const Products = ({ products = productsDefaultPropProducts }) => {
  const items = products.map(ingredient => {
    const { lineNumber: searchProduct, cqResponsive } = ingredient.products[0];
    return {
      searchProduct,
      cqResponsive,
      sponsored: ingredient.isSponsored,
    };
  });

  const nLoaded = useSelector(state => {
    const entities = getProducts(state);
    return items.reduce((acc, p) => (entities[p.searchProduct] ? acc + 1 : acc), 0);
  });

  return getFeatureFlags().shoppableRecipesMVP ? (
    <ProductGrid
      loading={products.length !== nLoaded}
      products={items}
      searchType="recipe"
      resetError={() => {}}
    />
  ) : null;
};

export default Products;

Products.propTypes = {
  products: RecipeProductTypes.products,
};
